/* assets/product-behind-the-bra.js.liquid */
(function(window, document, utils) {
  'use strict';
  window.SDG = window.SDG || {};
  
  SDG.behindTheBra = function() {
    var c = { dom: { carousel: 'js-btb-wrapper', btb_btn: 'js-btb-btn' } };
    var flickityCarousel, view;
    
    function init() {
      utils.windowResize(responsive);
      responsive();
    }
    
    function responsive() {
      utils.mq({
        view: 'phone',
        callback: function() {
          if (view !== 'phone') {
            var accordionButton = document.querySelector('.' + c.dom.btb_btn);
            if (accordionButton) {
              accordionButton.addEventListener('click', function() {
                if (flickityCarousel && typeof flickityCarousel.init === 'function') {
                  flickityCarousel.init();
                }
              });
            }
            initGallery();
            view = 'phone';
          }
        }
      });
      utils.mq({
        view: 'phone_to_desktop',
        callback: function() {
          if (view !== 'phone_to_desktop') { 
            destroyGallery(); 
            view = 'phone_to_desktop'; 
          }
        }
      });
    }
    
    function initGallery() {
      flickityCarousel = window.SDG.carousel({
        dom: { carousel: c.dom.carousel },
        flickityOpts: {
          draggable: true,
          prevNextButtons: false,
          pageDots: false,
          cellAlign: 'left',
          wrapAround: true,
          contain: true,
          groupCells: '80%',
          imagesLoaded: true
        }
      });
      flickityCarousel.init();
    }
    
    function destroyGallery() {
      if (flickityCarousel && typeof flickityCarousel.destroySlider === 'function') {
        flickityCarousel.destroySlider();
      }
    }
    
    init();
  };

})(window, document, window.utils);
